/* Here be dragons
⠤⢁⠄⠀⠀⠀⠀⠈⠙⠛⠷⣦⡄⡀⠀⠀⠀⠀⠀⠀⠤⣄⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⡤⠀⠀⢀⣴⠟⠁⠀⠀
⣶⢦⣦⣤⣤⣤⣤⣤⣄⣀⣀⣀⣉⠛⠳⣔⣤⡀⠀⠀⠀⣿⠆⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣸⣇⡀⣠⡿⠋⣀⣴⠶⠛
⠠⠀⠀⠀⠀⠀⠈⠀⠀⠀⠉⠈⠉⠉⠉⢛⣻⣿⣷⣶⣿⣿⠃⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢙⣿⣿⣿⡟⣛⠁⠀⠀⠀
⢂⠡⠀⠀⠀⠀⠀⠀⠀⠀⠀⣀⣤⡴⠾⠛⠉⣹⣿⣿⣿⡿⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢰⣀⣀⣤⣤⣤⣶⣶⢶⣤⣀⣀⠀⡀⠀⠀⠀⠀⠀⠀⠀⠘⣿⣿⢯⣍⠙⠛⠛⠛⠛
⠀⠄⠀⠀⠀⠀⢀⣀⣤⡼⠿⠟⠃⠀⠀⠀⣠⡿⢻⣿⣿⠃⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⣿⣿⠿⠿⢿⢻⣿⣿⢿⣿⢿⣼⣿⡀⠀⠀⠀⠀⠀⠀⠀⢿⣿⠀⠘⢿⣄⠀⠀⠀
⠈⢄⣶⣶⣶⠿⠟⠋⠉⠀⠀⠀⠀⠀⠀⣼⠟⠅⢸⣿⡏⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣤⣾⢷⡯⢗⣻⡖⠓⢒⣃⣤⣄⣠⣾⣿⡇⠀⠀⠀⠀⠀⠀⠀⣿⣿⠀⠀⠀⠙⢻⣦⡄
⣼⡿⠟⠉⠀⠀⠀⠀⠀⠀⠀⠀⠀⢠⣾⠃⠰⠀⣿⣿⠂⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⡺⣻⣯⣿⣙⣾⡟⢸⠺⣿⣿⣿⡟⢉⠏⠉⠀⠀⠀⠀⠀⠀⠀⠀⣿⣿⡄⠀⠀⠀⠀⠙⢿
⢡⠀⠄⠀⢀⠀⠀⠀⠀⠀⠀⠀⣴⡿⠁⠀⠀⢰⣿⣿⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢼⣇⠎⣸⢣⡟⢃⣏⣓⢷⡹⣿⣿⡇⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣾⣿⡇⠀⠀⠄⠀⠀⠌
⢢⢉⠄⠃⢄⠀⠂⠀⠀⠀⠀⣼⡟⠁⠀⠀⠀⣾⣿⣽⠨⠀⡀⠀⠀⠀⠀⠀⠀⠀⠠⢿⠀⠁⣇⠊⠠⢞⠋⠉⠉⠑⣽⢿⣿⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣾⣿⡄⠀⠀⡜⢠⡉⠖
⠥⣊⠌⡅⢢⠈⢅⠂⠄⠂⣸⡿⢁⠀⠤⠀⠀⣿⣿⠇⠀⠀⠀⠐⠀⠀⠀⠀⠀⠀⠀⣿⣁⡆⡟⠀⠀⢲⠀⠀⠀⠀⠈⠪⠾⠛⠀⠀⠀⠀⠀⠀⠀⠀⠀⡤⣿⣿⠂⡀⡐⣌⠣⡜⣩
⢒⡡⢊⠴⣁⠚⣄⠊⠤⣡⣿⠁⠆⡈⠔⠀⠀⣿⣿⢇⠀⠀⠀⠀⠀⠑⠀⠀⠀⠀⠈⢙⣏⣴⠹⡠⢀⠠⠐⠠⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢸⣿⣿⡐⠤⡑⣌⠳⣜⡵
⢢⠘⣌⠲⢌⡓⡌⣍⢲⡿⡡⢎⡐⠬⠀⠐⠀⣿⣯⢧⠀⠀⠀⠀⠀⠀⡀⠀⠀⠀⠀⠀⠹⣖⡆⠈⠢⡢⠀⠀⠈⠐⢄⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠄⣾⡿⣿⢀⠧⣑⠮⣝⢮⣳
⢀⢉⡀⢷⡈⢶⢱⣈⣿⢇⡱⢆⡸⠆⠀⠁⠀⣿⣏⢿⠀⠀⠀⠀⠀⠀⠆⠀⠀⠀⠀⠀⠀⠈⢿⣇⠁⣀⠆⠆⠀⠀⠀⠰⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢸⣾⣿⡇⡎⢶⣉⡾⣹⡾⢷
⢈⠢⡘⢆⡙⣆⢧⣿⣏⠞⣔⠣⡜⢡⠂⡁⠀⢿⣿⣟⡀⠄⠂⠀⠀⠀⠐⠀⠀⠀⠀⠀⠀⠀⠀⠙⠻⣬⠦⠀⢄⠀⠀⠀⠀⠢⠀⠀⠀⠀⠀⠀⠀⢰⣟⣾⡿⢱⡘⢦⡻⣼⣳⢟⡿
⠀⢢⠑⡎⣵⢪⣿⣟⣬⢻⣌⠷⣌⢣⡘⠀⠀⢸⣿⣿⡷⣈⠁⠈⠀⠐⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠈⠳⣮⠠⡵⠀⠀⠀⠀⢁⠀⠀⠀⠀⢀⠴⢋⣿⢻⢃⠧⣜⢧⣟⣳⢯⣿⠙
⠀⢢⡙⡜⣶⣻⣟⡾⣼⢳⣎⢷⣊⢦⡙⠤⠀⣼⣿⣿⣿⣦⡑⠀⠄⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣸⣷⣷⡀⠀⠀⠀⠘⠀⠀⢀⠴⡁⣰⠞⣿⣿⢘⢮⡝⣾⡽⣫⠟⠁⠀
⠀⢥⢪⢵⣣⣿⣻⢾⣽⣳⣻⢮⣝⡮⡵⣉⢦⣿⡿⠀⠈⠙⠻⢷⣦⣀⡅⢠⠐⠠⠄⣀⠀⣠⠄⠢⠂⠝⠋⢻⣿⡒⠠⠄⣀⠀⢐⠆⠂⠐⣴⠟⠉⠀⣿⣏⢞⣮⣽⣳⡟⠁⠀⠀⠀
⠣⣎⢮⣳⣿⣻⣽⣻⣞⡷⣯⣟⡾⣵⡳⣕⣾⣿⠃⡄⠀⠀⠀⠀⠈⠉⠛⠿⢶⣥⣴⣠⡞⠀⠂⠀⣥⠈⡁⡢⠗⣀⠠⠀⡀⠀⢸⢘⡼⠟⠁⠀⢠⠌⣿⣏⡾⣮⢷⡛⠁⠀⠀⠀⠀
⠀⠻⣮⢷⣿⣳⢯⡷⣯⣟⡷⣯⣟⣷⣻⢞⣿⢧⣋⠴⡩⢔⢢⡐⡀⠄⡀⢀⠀⣤⣾⢻⠄⠒⡉⠐⡬⠐⠈⠊⡀⠀⠡⠁⠒⠐⠻⣨⠇⣠⢂⡍⢦⡙⣿⣯⢷⣯⡟⠀⠀⠀⠀⠀⠀
⠀⠀⢫⣿⢷⣯⠿⠙⠓⠯⣟⣷⣻⢾⣽⣻⣟⣳⣎⢷⣙⣎⢦⡱⣍⣶⡷⣞⢿⣛⣬⡻⡌⠡⡀⣷⠇⠁⢀⠀⠈⠂⢁⣐⡀⡼⢨⢈⡗⣦⢳⡜⣧⣻⣽⣯⣟⡞⠀⠀⠀⠀⠀⠀⠀
⠀⠀⢺⣿⠋⠀⠀⠀⠀⠀⠘⣷⣯⣿⣾⣿⣽⢳⡞⣯⣾⣼⢣⣷⣾⣯⣷⠛⡏⢹⡌⡆⢱⣤⡞⡍⠈⡄⠀⠑⡄⠈⡄⠀⠀⠀⢸⡌⢹⡞⣧⡟⣷⢻⣾⢳⣯⠃⠀⠀⠀⠀⠀⠀⠀
⠀⢀⡿⠉⠀⠀⠀⠀⠀⠀⠀⣿⣞⡷⣿⣯⣟⣯⢿⡽⣞⣧⣿⡿⣫⣿⢶⣎⣳⡼⣷⢿⠛⢡⠀⠱⡀⢈⠢⡀⢈⠠⠐⠀⠀⠈⣟⠁⣼⡿⣽⣻⣽⣻⢾⣟⡏⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠸⠁⠀⠀⠀⠀⠀⠀⠀⠀⢸⣯⢿⣟⣾⡽⣞⣯⢿⡽⣞⣯⣿⣟⣯⣿⡿⠿⡽⢃⠁⢃⠀⠳⠀⡑⢄⠀⠉⠐⠠⠤⠄⠐⣸⢧⣾⢿⣽⣳⣟⡾⣽⣻⣟⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⢀⠂⠀⠀⠀⠀⢸⣯⣿⣟⡾⣽⣻⣞⣯⢿⡽⣿⣻⡿⣾⣿⣵⢐⢳⡘⡄⠘⡂⠄⡑⢄⠠⠑⠪⠄⢀⠀⢀⣾⣽⣻⣞⡿⣞⡷⣯⣟⣷⣻⡝⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠈⠀⠀⠀⠈⠀⠀⣼⣻⣷⢯⡿⣽⣳⣟⡾⣯⣟⡷⣯⢿⡿⡟⣿⠘⡴⡅⠘⢄⠐⠠⢀⡂⢈⠐⢠⣐⣤⣾⣟⡽⣞⡷⣯⢿⣽⣻⢷⣻⢾⣽⠃⠀
*/
// Note: this import from CX should not be removed or moved. This is to override user agent style sheets from the browser.
import '@sanlam-glacier/app-common/cx/reset';
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

import { AppError } from 'modules/app/components/pages/app-error/AppError';
import { AppRoutes } from 'routes/AppRoutes';
import { AppStartupError } from 'modules/app/components/pages/app-startup-error/AppStartupError';
import { ConfigProvider } from 'providers/config/ConfigProvider';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorInfo } from 'react';
import { Theme } from 'modules/app/components/atoms/theme/Theme';
import { StateProvider } from './stores/app.store';
import { logger } from '@sanlam-glacier/app-common/modules/logger';
import { AuthProvider } from 'auth';

const App = () => {
  return (
    <ErrorBoundary FallbackComponent={AppStartupError}>
      <StateProvider>
        <ConfigProvider>
          <AuthProvider>
            <Theme>
              <ErrorBoundary
                FallbackComponent={AppError}
                onError={(error: Error, info: ErrorInfo) => {
                  logger.error({
                    message: 'App Crash',
                    object: { error, componentStack: info?.componentStack }
                  });
                }}
              >
                <AppRoutes />
              </ErrorBoundary>
            </Theme>
          </AuthProvider>
        </ConfigProvider>
      </StateProvider>
    </ErrorBoundary>
  );
};

export default App;
